import styled from 'styled-components';

import keuzeHulpBusImage from 'images/keuze-hulp-bus.png';

export const WelcomeImage = styled.img.attrs(() => ({
  alt: 'Bestelwagen',
  src: keuzeHulpBusImage,
}))`
  width: 100%;
  max-width: 600px;
  position: absolute;
  right: 0;
`;
